import { useCallback } from "react"
import {
  getAllStakingBakerySoccer,
  getAllStakingPokerCard,
  getPokerCardContract,
  getSoccerPokerGameBoxAddress,
  commonStakeERC721EarnERC20GetUserInfo,
  commonStakeERC721EarnBakeGetUserInfo,
  getCarNFTContract,
  getAllStakingCarNFTs,
} from '../../sushi/utils'

import { useActiveWeb3React } from '../'
import useYam from "../bakery/useYam"
import { NFTTYPE } from '../../constants/bakery/nft'
import { userNFTMasterContract } from '../../userType/userNFTMasterContract'

const useUserStakes = (type?: string) => {
  const { account } = useActiveWeb3React()
  const sushi = useYam()
  let exchangeNFTContract: any = userNFTMasterContract(sushi, type)
  let exchangeContract: any 
  switch (type) {
    case NFTTYPE.POKER:
      exchangeContract = getPokerCardContract(sushi)
      break
    case NFTTYPE.GAMEBOX:
      exchangeContract = getSoccerPokerGameBoxAddress(sushi)
      break
    case NFTTYPE.CAR:
      exchangeContract = getCarNFTContract(sushi)
      break
  }
  
  const userStakes = useCallback(async() => {
    if (!type) return []
    try {
      let userBids: Array<any> = []
      if(type && [NFTTYPE.SOCCER].includes(type)){
        userBids = await getAllStakingBakerySoccer(exchangeNFTContract, account)
      }else if(type && [NFTTYPE.POKER].includes(type)){
        let Arr = await getAllStakingPokerCard(exchangeNFTContract, exchangeContract, account)
        userBids = Arr.map((d: any) => {
          return d.tokenId
        })
      }else if(type && [NFTTYPE.GAMEBOX].includes(type)){
        let Arr = await commonStakeERC721EarnERC20GetUserInfo(exchangeNFTContract, exchangeContract, account)
        userBids = Arr[2]
      }else if(type && [NFTTYPE.CAR].includes(type)){
        let Arr = await getAllStakingCarNFTs(exchangeNFTContract, exchangeContract, account)
        userBids = Arr.map((d: any) => {
          return d.tokenId
        })
      }else if(type && [
        NFTTYPE.CAR_V2,
        NFTTYPE.CAR_V3,
        NFTTYPE.DOGGIES, 
        NFTTYPE.DOGGIES_V2,
        NFTTYPE.DOGGIES_V3,
        NFTTYPE.BARKING,
        NFTTYPE.BARKING_V2,
        NFTTYPE.BARKING_V3,
        NFTTYPE.MATRIX,
        NFTTYPE.POKER_V2,
        NFTTYPE.POKER_V3,
        NFTTYPE.EQUIPMENT,
        NFTTYPE.EQUIPMENT_V2,
        NFTTYPE.EQUIPMENT_V3,
        NFTTYPE.BAKEMUSKMIXER,
        NFTTYPE.BAKEMUSKMIXER_V2,
        NFTTYPE.BAKEMUSKMIXER_V3,
        NFTTYPE.SOCCER_V2,
        NFTTYPE.SOCCER_V3,
        NFTTYPE.COMBO_V2, 
        NFTTYPE.COMBO_V3, 
      ].includes(type)){
        let Arr = await commonStakeERC721EarnBakeGetUserInfo(exchangeNFTContract, account)
        userBids =[...Arr[2]]
      }
      const list = userBids.map((d: any) => {
        return d
      })
      return list
    } catch (e) {
      console.log(e)
      return []
    }
  }, [account, exchangeNFTContract, exchangeContract, type])
  return userStakes
}

export default useUserStakes